import { animate, style, transition, trigger } from '@angular/animations';

export const optionsContainer = trigger('optionsContainer', [
  transition(':enter', [style({ opacity: 0, transform: 'translateY(-10px)' }), animate('150ms ease-in', style({ opacity: 1, transform: 'translateY(0px)' }))]),
  transition(':leave', [animate('150ms ease-out', style({ opacity: 0, transform: 'translateY(-10px)' }))]),
]);
